import Fortmatic from 'fortmatic';
import { treasury } from '../stateManagement/Treasury';

export const getFortmaticProvider = async (rpcUrl: string, networkId: number) => {
  const fortmatic = new Fortmatic(treasury.fortmatic, { rpcUrl, chainId: +networkId });
  const provider = fortmatic.getProvider();
  await provider.enable();
  return { provider, connector: fortmatic };
};
